export enum ClientId {
  RISR_APPLY = 'eas',
  RISR_ADVANCE = 'kaizen'
}

export enum CredentialTypes {
  LOCAL = 'local',
  PROXY = 'proxy',
  API = 'api'
}

export enum MFAMethodsEnum {
  EMAIL_OTP = 'email_otp',
  TOTP = 'totp'
}

export interface MFAMethod {
  id: MFAMethodsEnum;
  name: string;
  secure: boolean;
}

export const orderedMFAMethods: MFAMethod[] = [
  { id: MFAMethodsEnum.TOTP, name: 'Authenticator', secure: true },
  { id: MFAMethodsEnum.EMAIL_OTP, name: 'Email', secure: false },
];


export class Organisation {
  id: string;
  name: string;
  shortName: string;

  enabledLabs: boolean;
  allowedAccountTypes: CredentialTypes[];
  enabledMFAs: MFAMethod[];

  constructor(doc) {
    this.id = doc.id
    this.name = doc.name;
    this.shortName = doc.shortName;
    this.enabledLabs = doc.enabledLabs;
    this.enabledMFAs = this.convertMFAIdToMFAMethod(doc.enabledMFAs || []);
    this.allowedAccountTypes = this.convertAllowedAccountTypes(doc.allowedAccountTypes || []);
  }

  private convertAllowedAccountTypes(allowedAccountTypes: string[]): CredentialTypes[] {
    if (allowedAccountTypes.includes('__all__')) {
      return [CredentialTypes.LOCAL, CredentialTypes.PROXY];
    }

    return allowedAccountTypes as CredentialTypes[];
  }

  private convertMFAIdToMFAMethod(enabledMFAs: MFAMethodsEnum[]): MFAMethod[] {
    return orderedMFAMethods.filter(method => enabledMFAs.includes(method.id));
  }
}
